import React, {Component} from 'react';
import classes from './SearchWindow.css';
import ResultTable from '../../../UI/DataTable/DataTable';
import DisplayBox from '../../../hoc/DisplayBox/DisplayBox';
import QuickSearchForm from "./QuickSearch/QuickSearch";
import AdvancedSearchForm from "./AdvancedSearch/AdvancedSearch";
import Message from '../../../components/Message/Message';
import SearchPaginationBtns from './SearchPaginationBtns';
import { ID_TYPE_NEW } from '../../../shared/Constants';

class SearchWindow extends Component {

    state = {
        linkLabel: null,
        formHeader: null,
        formMessage: null,
        searchResultPageNumber: 1 
    }

    formHeaderHandler = (data) => {
        this.setState({
            linkLabel: data.linkLabel,
            formHeader: data.formHeader,
            formMessage: data.formMessage
        });
    }

    setPageNumber = (pageNo) => {
        this.setState({
            searchResultPageNumber : pageNo
        })
    }

    isNextDisabled = (currentPageDataCount) => {
        return this.props.searchResult.length - ((this.state.searchResultPageNumber-1) * this.props.searchDataLimitPerPage + currentPageDataCount) === 0;
    }

    getPaginatedData = (data) => {
        const startIndex = this.state.searchResultPageNumber * this.props.searchDataLimitPerPage - this.props.searchDataLimitPerPage;
        const endIndex = startIndex + this.props.searchDataLimitPerPage;
        const result = data.slice(startIndex, endIndex);
        return result;
      };

    resetQuickSearch = () => {
        this.setPageNumber(1);
        this.props.resetSearch();
    }

    resetAdvancedSearch = () => {
        this.setPageNumber(1);
        this.props.clearSearch();
    }

    render() {
        // Search Form
        let searchForm = null;
        if(this.props.quickSearch) {
            searchForm = <QuickSearchForm resetSearch={this.resetQuickSearch} clearPersistedSearch={this.props.clearPersistedSearch} searchedKey={this.props.searchedKey} backNavigationSearchedKey={this.props.backNavigationSearchedKey} headerHandler={this.formHeaderHandler} searched={this.props.searched} errorHandler={this.props.errorHandler} setSearchResults={this.props.setSearchResults}/>;
        } else {
            searchForm = <AdvancedSearchForm clearSearch={this.resetAdvancedSearch} clearPersistedSearch={this.props.clearPersistedSearch} initialSearchRequest={this.props.initialSearch} backNavigationSearch={this.props.backNavigationSearch} headerHandler={this.formHeaderHandler} searched={this.props.searched} errorHandler={this.props.errorHandler} setSearchResults={this.props.setSearchResults}/>
        }

        // Search Results
        const resultColumnMapping = [
            {dataField: 'firstName', text: 'First Name', title: true},
            {dataField: 'lastName', text: 'Last Name', title: true},
            {dataField: 'userName', text: 'Username', title: true},
            {dataField: 'phone', text: 'Phone', title: true},
            {dataField: 'email', text: 'Email', title: true},
            {dataField: 'idType', text: 'ID Type', headerAlign:'center', align:'center'}
        ];

        let searchResult = null;
        
        if(this.props.searchResult && this.props.searchResult.length > 0) {
            let data = []
            this.props.searchResult.forEach(item => {
                const itm = {...item};
                itm.idType = ID_TYPE_NEW[itm.idType];
                data.push(itm);
            });
            let paginatedData = this.getPaginatedData(data);
            let searchPaginationBtns =  <SearchPaginationBtns 
                                nextClick = {this.setPageNumber}
                                nextDisabled = {() => this.isNextDisabled(paginatedData.length)}
                                pageNumber = {this.state.searchResultPageNumber}
                            />
            searchResult =
                <ResultTable
                    title="Member Search Results"
                    data = {paginatedData}
                    columns={resultColumnMapping}
                    clicked={this.props.selected}
                    paginationComponent={searchPaginationBtns}

                />
        }

        let displayMessage = this.props.displayMessage? <Message msgType={this.props.displayMessage.type} info={this.props.displayMessage.info} />: null;

        return (
            <DisplayBox>
                <div className={classes.SearchWindow}>
                    <h2 className={classes.FormTitle}>{this.state.formHeader}</h2>
                    <p className={classes.Message}>{this.state.formMessage}</p>
                    <Message msgType="Error" info={this.props.error} />
                    {displayMessage}
                    {searchForm}
                </div>
                {searchResult}
            </DisplayBox>
        );
    }
}

export default SearchWindow;
